(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("consignmentMenuService", [function () {
        let service = {};

        return service;
    }]);
})();
